import React from "react";

// Modules
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

// App
import { getOnlineNode } from "../../core/getNode";
import Comment from "./comment";
import CommentForm from "./commentForm";
import { alertMessages } from "../alertMessages";
import Error from "../error";

// UI
import { Row, Col } from "react-bootstrap";
import { Typography, CircularProgress, Button } from "@mui/material";
import CommentIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import TimeIcon from "@mui/icons-material/AccessTimeOutlined";

const pageSize = 10;

export default function CommentSection(props) {
  const user = useSelector((state) => state).authReducer.user;
  const [comments, setComments] = useState([]);
  const [isError, setIsError] = useState(false);
  const [errorStatus, setErrorStatus] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [loadMore, setLoadMore] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    getComments();
    // eslint-disable-next-line
  }, [currentPage]);

  const getComments = () => {
    if (props.nid) {
      const path = `api/v2/comments/${props.nid}?items_per_page=${pageSize}&page=${currentPage}`;

      getOnlineNode(path, user.access_token)
        .then((response) => {
          setComments((prevData) => [...prevData, ...response.data.rows]);
          setTotalItems(parseInt(response.data.pager.total_items, 10));
          setIsLoading(false);
          setLoadMore(false);
        })
        .catch((_error) => {
          if (_error.response) {
            _setError(true, _error.response.status, _error.response.statusText);
          } else if (_error.request) {
            _setError(true, 0, alertMessages.requestError.message);
          } else {
            _setError(true, 0, alertMessages.unkownError.message);
          }
        });
    }
  };

  /**
   * @function setError
   * @description Updates the state of the component upon an error
   * @param {boolean} _isError
   * @param {int} _errorStatus
   * @param {string} _errorMessage
   */
  const _setError = (_isError, _errorStatus, _errorMessage) => {
    setIsLoading(false);
    setLoadMore(false);

    setIsError(_isError);
    setErrorStatus(_errorStatus);
    setErrorMessage(_errorMessage);
  };

  if (isLoading) {
    return (
      <Col className="w-100">
        <Row className="comment-section-container gx-0 justify-content-center">
          <CircularProgress size={18} />
        </Row>
      </Col>
    );
  } else {
    return (
      <>{
        isError ? (
          <Error status={errorStatus} message={errorMessage} />
        ) : (
          <Col className="w-100">
            <Row className="comment-section-container gx-0">
              <Col>
                {props.field_allow_comments === "true" && (
                  <Row className="comments-container gx-0">
                    <Col>
                      <Typography
                        owner="client"
                        variant="h2"
                        className="mb-3  d-flex align-items-center"
                        color="clientText.main"
                      >
                        <CommentIcon className="me-2" sx={{ fontSize: "2rem" }} />
                        Comments
                      </Typography>
                      <CommentForm
                        user={user}
                        nid={props.nid}
                        onCommentPosted={(data) => {
                          getComments();
                        }}
                      />
                      {comments.length > 0 && (
                        <Row className="gx-0 mb-3">
                          <Typography
                            className=" d-flex align-items-center"
                            owner="client"
                            variant="h5"
                            color="clientText.main"
                          >
                            <TimeIcon
                              className="me-2"
                              sx={{ fontSize: "1.5rem" }}
                            />
                            Most Recent
                          </Typography>
                        </Row>
                      )}
                      {comments.map((e, i) => {
                        return <Comment key={`c-${i}`} user={user} comment={e} />;
                      })}
                      {totalItems > comments.length &&
                        <Row className="d-flex align-items-center justify-content-center">
                          <Col xs={5} sm={3}>
                            <Button
                              className="w-100"
                              owner="admin"
                              variant="contained"
                              dialogBtn="true"
                              dialogVariant="primary"
                              onClick={() => {
                                setCurrentPage((prevData) => prevData + 1);
                                setLoadMore(true);
                              }}
                            >
                              {loadMore ? (
                                <CircularProgress
                                  className="p-1"
                                  sx={{ color: '#fff' }}
                                  size={31}
                                />
                              ) : (
                                "Load more"
                              )}
                            </Button>
                          </Col>
                        </Row>
                      }
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          </Col>
        )}
      </>
    );
  }
}
